import editor from "./editor";
import commonHelpers from "common/plugins/issues/empty_parent";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
